import React from 'react';
import { theme } from './theme';

interface DropdownMenuProps {
	header?: string | React.ReactNode;
	children: React.ReactNode;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ header, children }) => {
	return (
		<div style={theme.menu}>
			{header && <header style={theme.header}>{header}</header>}
			<ul role="menu">{children}</ul>
		</div>
	);
};

export default DropdownMenu;
